import axios from 'axios';
import React, { useEffect, useState } from 'react'
import ContentLoader from 'react-content-loader';
import { Helmet } from 'react-helmet'
import { Link, useParams } from 'react-router-dom';
import helpers from '../helper';

export default function Servicedetail() {
  const params = useParams();
  const [services, setServices] = useState();
  const [pageloader, setPageloader] = useState(false);
  useEffect(() => {
    setPageloader(true);
    async function fetchService() {
      await axios.get(process.env.REACT_APP_API + 'api/services/' + params.alias).then((response) => {
        setServices(response.data.result);
        setPageloader(false);
      });
    }
    fetchService();
  }, [params]);
  return (
    <>
      <Helmet>
        <title>{services ? services.meta_title : 'This service is not available yet'}</title>
        <meta name="description" content={services ? services.meta_description : 'This service is not available yet'} />
        <meta name="keywords" content={services ? services.meta_keywords : 'This service is not available yet'} />
      </Helmet>
      <main>
        <section className="InnerHead bgthm2">
          <img loading="lazy" src={require("../assets/img/img-bg.svg").default} alt="Service Details" className="imgbg" width="1600" height="453" />
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-8 text-center">
                <h1 className="fw-normal text-white">{services ? services.title : 'This service is not available yet'}</h1>
                <ol className="breadcrumb m-0 justify-content-center">
                  <li className="breadcrumb-item"><Link to="/"><img src={require("../assets/img/home.svg").default} width="14" height="14" alt="Home" /></Link></li>
                  <li className="breadcrumb-item"><Link to="/services">Services</Link></li>
                  <li className="breadcrumb-item"><span aria-current="page">{services ? services.title : 'This service is not available yet'}</span></li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section className="Home">
          <div className="container mb-5">
            {
              pageloader ?
                <ContentLoader height={475} width={1260} backgroundColor="#f5f5f5"
                foregroundColor="#dbdbdb">
                  <circle cx="25" cy="112" r="15" />
                  <circle cx="25" cy="160" r="15" />
                  <circle cx="25" cy="210" r="15" />
                  <rect x="10" y="18" rx="0" ry="0" width="900" height="9" />
                  <rect x="950" y="10" rx="0" ry="0" width="844" height="244" />
                  <rect x="10" y="41" rx="0" ry="0" width="900" height="9" />
                  <rect x="10" y="65" rx="0" ry="0" width="800" height="9" />
                  <rect x="50" y="100" rx="0" ry="0" width="715" height="9" />
                  <rect x="50" y="120" rx="0" ry="0" width="715" height="10" />
                  <rect x="50" y="150" rx="0" ry="0" width="715" height="9" />
                  <rect x="50" y="170" rx="0" ry="0" width="715" height="10" />
                  <rect x="50" y="200" rx="0" ry="0" width="715" height="9" />
                  <rect x="50" y="220" rx="0" ry="0" width="715" height="10" />
                  <rect x="10" y="250" rx="0" ry="0" width="900" height="9" />
                  <rect x="10" y="270" rx="0" ry="0" width="1500" height="9" />
                  <rect x="10" y="290" rx="0" ry="0" width="1500" height="9" />
                  <rect x="10" y="310" rx="0" ry="0" width="1500" height="9" />
                  <rect x="10" y="330" rx="0" ry="0" width="1500" height="9" />
                  <rect x="10" y="350" rx="0" ry="0" width="1500" height="9" />
                  <rect x="10" y="370" rx="0" ry="0" width="1500" height="9" />
                </ContentLoader>

                :
                <div className="row">
                  {
                    services ?
                      <div className="col-12 CmsPage">
                        {
                          helpers.helpers1(services.image) ?
                            <picture className="img">
                              <img loading="lazy" src={process.env.REACT_APP_IMAGE + 'uploads/service/' + services.image} alt={services.title} className="h-auto float-md-end mb-md-5 ms-md-5 col-md-3" width="900" height="453" />
                            </picture>
                            :
                            <picture className="img">
                              <source srcSet={process.env.REACT_APP_IMAGE + 'uploads/service/webp/' + services.image + '.webp'} type="image/webp" />
                              <source srcSet={process.env.REACT_APP_IMAGE + 'uploads/service/avif/' + services.image + '.avif'} type="image/avif" />
                              <img loading="lazy" src={process.env.REACT_APP_IMAGE + 'uploads/service/jpg/' + services.image + '.jpg'} alt={services.title} className="h-auto float-md-end mb-md-5 ms-md-5 col-md-3" width="900" height="453" />
                            </picture>
                        }
                        <div dangerouslySetInnerHTML={{ __html: services.description }} />
                      </div>
                      :
                      'This service is not available yet'
                  }
                </div>
            }

          </div>
        </section>
      </main>
    </>
  )
}
